import React, { useEffect, useState } from 'react'
import Modal from '../Modal/ModalTS'
import FocusableButtonTS from '../FocusableButton/FocusableButtonTS'
import tts from '../../lib/TTS'
import {
  platformStoreDelete,
  platformStoreGet,
} from '../../../../shared/helpers'
import {
  KeyTypeEnum,
  useKeyDownHandler,
} from '../../../../shared/hooks/useKeyDownHandler'

import type { ResumeWatchingModalProps } from './types'

const RESUME_WATCHING = 'Resume Watching'
const PLAY_FROM_BEGINNING = 'Play from Beginning'

function ResumeWatchingModal(props: ResumeWatchingModalProps) {
  const [reconnectionMessage, setReconnectionMessage] = useState('')

  useKeyDownHandler(
    [KeyTypeEnum.Back],
    () => {
      props.onBackPress()
    },
    false
  )

  useEffect(() => {
    const reconnection = platformStoreGet('connectionMessage')
    if (reconnection) {
      setReconnectionMessage(reconnection)
      tts.pushTextToRead(reconnectionMessage)
    }
    return () => {
      platformStoreDelete('connectionMessage')
    }
  }, [])

  const readTts = (message: string) => {
    tts.pushTextToRead(message)
  }

  return (
    <div className="resume-watching-modal">
      <Modal error={true}>
        <div>{reconnectionMessage}</div>
        <FocusableButtonTS
          onEnterPress={props.onResumeWatching}
          onFocus={() => readTts(RESUME_WATCHING)}
          stealFocus={true}
        >
          {RESUME_WATCHING}
        </FocusableButtonTS>
        <FocusableButtonTS
          onEnterPress={props.onPlayFromBeginning}
          onFocus={() => readTts(PLAY_FROM_BEGINNING)}
        >
          {PLAY_FROM_BEGINNING}
        </FocusableButtonTS>
      </Modal>
    </div>
  )
}

export default ResumeWatchingModal
